import SimpleButtonFilteredDropdown from './SimpleButtonFilteredDropdown';

export default SimpleButtonFilteredDropdown;